const Keys = {
    codes: {
        tab: 9,
        return: 13,
        shift: 16,
        control: 17,
        alt: 18,
        escape: 27,
        spacebar: 32,
        arrowLeft: 37,
        arrowUp: 38,
        arrowRight: 39,
        arrowDown: 40,
        meta: 91
    },
    isArrowKey: (keycode) => {
        if (keycode === Keys.codes.arrowUp
            || keycode === Keys.codes.arrowDown
            || keycode === Keys.codes.arrowLeft
            || keycode === Keys.codes.arrowRight) {
            return true;
        }

        return false;
    }
};

export default Keys;